import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeployments = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1795_1808)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M12.5 14C13.3284 14 14 13.3284 14 12.5C14 11.6716 13.3284 11 12.5 11C11.6716 11 11 11.6716 11 12.5C11 13.3284 11.6716 14 12.5 14Z",
					stroke: "black",
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.5 15V14",
					stroke: "black",
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.5 11V10",
					stroke: "black",
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15 12.5H14",
					stroke: "black",
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11 12.5H10",
					stroke: "black",
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.3197 14.3197L13.6797 13.6797",
					stroke: "black",
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.3546 11.3202L10.7146 10.6802",
					stroke: "black",
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.3199 10.6802L13.6799 11.3202",
					stroke: "black",
					strokeLinejoin: "bevel"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.3199 13.6802L10.6799 14.3202",
					stroke: "black",
					strokeLinejoin: "bevel"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 2.5L14 2.5",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 7.5L14 7.5",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 12.5H9",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 13L3 14L5 12",
			stroke: "black",
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 8L3 9L5 7",
			stroke: "black",
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 3L3 4L5 2",
			stroke: "black",
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1795_1808",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 5,
				height: 5,
				fill: "white",
				transform: "translate(10 10)"
			})
		}) })
	]
});
export default SvgDeployments;
